import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import { Paper } from "@mui/material";
import Footer from "../Footer/Footer";
import Carousel from "./Carousel";
import { Header2 } from "../NavBar/Header2";
import "./Updates.css";
import "../../App.css";
const Updates = () => {
  const bearerToken =
    "AAAAAAAAAAAAAAAAAAAAALp7igEAAAAANp4Vs8FarboonNnk6%2B8pKAwHEZk%3DOiOXdGBJ7v6Apu7IwWTLARZAfjYMDc28eyKK4X73uswqOANa0Q";

  const [tweets, setTweets] = useState([]);

  useEffect(() => {
    async function fetchTweets() {
      try {
        const response = await axios.get(
          `https://api.twitter.com/2/users/25852858/timelines/reverse_chronological?tweet.fields=created_at&expansions=author_id&user.fields=created_at&max_results=10`,
          {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
            },
          }
        );

        setTweets(response.data.data);
      } catch (error) {
        console.error("Error fetching tweets:", error);
      }
    }

    fetchTweets();
    document.title = "Updates";
  }, []);
  return (
    <>
      <Header2 />
      <div className="updates">
        <h1 style={{ color: "#494b4d", textAlign: "center", width: "100%" }}>
          Updates
        </h1>
        <p>&nbsp;</p>
        <div className="load">
          <h2>Sunrise Updates</h2>
          <p>&nbsp;</p>
          <Carousel />
          {/* <p>&nbsp;</p> */}
          <h2>Social Media Updates</h2>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <div className="social_layout">
            <div className="twit">
              {tweets.map((tweet, index) => (
                <div key={index}>{tweet.text}</div>
              ))}
              <Helmet>
                <script
                  async
                  src="https://platform.twitter.com/widgets.js"
                  charset="utf-8"
                ></script>
              </Helmet>
            </div>
            <div className="inst">
              <Paper elevation={1} style={{ borderRadius: 8 }}>
                <div className="insta">
                  <a
                    id="instalink"
                    href="https://www.instagram.com/_sunrise.study/"
                  >
                    <strong>Latest posts by _sunrise.study</strong>
                  </a>
                  <button id="insta_follow">
                    <strong>Follow on Instagram</strong>
                  </button>
                </div>
                <hr style={{ borderColor: "#d4d4d4", borderStyle: "solid" }} />
                <div className="insta_widget">
                  <figure
                    className="insta_figure"
                    data-behold-id="uHoiNK0jcxtkgIetHUmt"
                  ></figure>
                  <Helmet>
                    <script
                      src="https://w.behold.so/widget.js"
                      type="module"
                    ></script>
                  </Helmet>
                </div>
                <hr style={{ borderColor: "#d4d4d4", borderStyle: "solid" }} />
                <button
                  style={{
                    borderRadius: "10rem",
                    padding: "10px",
                    color: "white",
                    background: "#e86602",
                    fontSize: "15px",
                    marginLeft: "35%",
                    marginTop: "10px",
                    marginBottom: "10px",
                    borderStyle: "none",
                  }}
                >
                  <strong>
                    <a
                      href="https://www.instagram.com/_sunrise.study/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      View more on Instagram
                    </a>
                  </strong>
                </button>
              </Paper>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Updates;
